require('./scripts/sendReferrer.js')
require('./scripts/sendConsentString.js')
require('./scripts/sendAdDynamics.js')
require('./scripts/playerEventsToDataLayer.js')



// WEBPACK FOOTER //
// ./src/parent.js